/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/theme/dracula.css';

import React from 'react';
import {
  Row,
  Col,
  Panel,
  Grid,
  Table,
  ControlLabel,
} from 'react-bootstrap';
import format from 'date-fns/format';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import Codemirror from 'react-codemirror';
import Toolbar from 'loracoms/Toolbar';
import CollapseToggle from 'loracoms/CollapseToggle';
import RichButton from 'loracoms/RichButton';
import LineChart from 'loracoms/LineChart';
import PanelToolbar from 'loracoms/PanelToolbar';
import Select from 'loracoms/Select';
import { compactFormat } from 'lorautils/DateTimeUtils';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  syntaxCheck,
  saveParserWithApp,
  loadParserWithApp,
} from './../../func/parser';
import './coms/Codemirror/codemirror.css';
import styles from './styles.scss';

const kHelp = '/*\n' +
  'Define your custom javascript data decoder here.\n' +
  '  The following variables are available: \n' +
  '  data     : hex string of the data\n' +
  '  hex      : array of bytes represented as string of 2 hex digits\n' +
  '  bin      : array of bytes represented as integers\n' +
  '  appeui   : application EUI\n' +
  '  deveui   : device EUI\n' +
  '  fport    : message port field\n' +
  '  Last line of your script will be printed to the data payload column.\n\n' +
  'For instance, RXHF RHF1S001 data can be parsed like:\n\n' +
  '  var temperature = Number((bin[2]*256+bin[1]) * 0.00268 - 46.85).toFixed(2);\n' +
  '  var humidity=Number(bin[3] * 0.49-6).toFixed(2);\n' +
  '  ["T="+temperature+"˚C", "H="+humidity+"%"].join("  ")\n' +
  '  var obj={\n' +
  '              "T(˚C)": temperature,\n' +
  '              "H(%)": humidity,\n' +
  '              "length": data.length\n' +
  '           };\n' +
  '  JSON.stringify(obj);*/\n' +
  'data;';

const defaultProps = {
};

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  wsStatus: React.PropTypes.string.isRequired,
  wsType: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  data: React.PropTypes.array.isRequired,
  onSaveParser: React.PropTypes.func.isRequired,
};

class ParserView extends React.Component {
  constructor(props) {
    super(props);
    let deveui;
    let fport;
    if (props.data && props.data.length > 0) {
      deveui = props.data[0].deveui;
      fport = props.data[0].fport;
    }
    this.state = {
      wsStatus: props.wsStatus,
      wsType: props.wsType,
      scripts: loadParserWithApp(props.appId) || kHelp,
      parserErr: '',
      dataList: props.data || [],
      showParser: true,
      showLineChartStatus: false,
      submitStatus: '',
      deveui,
      fport,
    };
    this.intlMsg = new IntlMsg(props.intl, 'appdebug');
    this.handleSaveScript = this.handleSaveScript.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { data, wsStatus, wsType } = nextProps;
    if (data !== this.props.data) {
      this.setState({ dataList: data });
      let { deveui = '', fport = '' } = this.state;
      if (deveui === '' || fport === '') {
        if (data && data.length > 0) {
          deveui = data[0].deveui;
          fport = data[0].fport;
        }
        this.setState({ deveui, fport });
      }
    }
    if (wsStatus !== this.props.wsStatus) {
      this.setState({ wsStatus });
    }
    if (wsType !== this.props.wsType) {
      this.setState({ wsType });
    }
  }

  codeChange(code) {
    if (syntaxCheck(code)) {
      this.setState({ scripts: code, parserErr: syntaxCheck(code) });
    } else {
      this.setState({ scripts: code, parserErr: '' });
    }
  }

  handleSaveScript() {
    const { appId } = this.props;
    const { scripts } = this.state;
    this.setState({ submitStatus: 'loading' });
    saveParserWithApp(appId, scripts);
    this.props.onSaveParser(scripts);
    this.setState({ submitStatus: 'success' });
  }

  deveuiOptions() {
    const { dataList = [] } = this.state;
    return _.map(dataList, item => ({
      label: item.deveui,
      value: item.deveui,
    }));
  }

  fPortOptions(deveui) {
    const { dataList = [] } = this.state;
    return _.map(
      _.filter(dataList, item => item.deveui === deveui),
      item => ({
        label: item.fport,
        value: item.fport,
      }));
  }

  renderParser() {
    const {
      scripts,
      parserErr,
      parserExpanded = true,
      submitStatus,
    } = this.state;

    const header = (
      <div>
        {this.intlMsg.msg('detailview.parser')}
        <ul className="icontools">
          <li>
            <CollapseToggle
              expanded={parserExpanded}
              onChange={v => this.setState({ parserExpanded: v })}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <div>
        <Panel
          bsStyle="aisz-white"
          header={header}
          collapsible
          expanded={parserExpanded}
        >
          <Codemirror
            value={scripts}
            onChange={code => this.codeChange(code)}
            options={{ lineNumbers: true, mode: 'javascript', theme: 'dracula' }}
          />
          <div className={styles.submit}>
            <RichButton
              status={submitStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('parserview.savescript'),
                onClick: this.handleSaveScript,
              }, {
                status: 'loading',
                label: (
                  <span>
                    <i className="fa fa-spinner fa-spin" />{' '}
                    {this.intlMsg.msg('parserview.savescript.pending')}
                  </span>
                ),
                onClick: () => {},
              }, {
                status: 'success',
                label: (
                  <span>
                    <i className="fa fa-check-circle" />{' '}
                    {this.intlMsg.msg('parserview.savescript.success')}
                  </span>
                ),
                style: 'success',
                onClick: () => {},
                timer: () => { this.setState({ submitStatus: '' }); },
              }]}
            />
          </div>
          <div>{parserErr}</div>
        </Panel>
      </div>
    );
  }

  renderWsStatus() {
    const { wsStatus } = this.state;
    if (wsStatus === 'connected') {
      return <i className="fa fa-refresh fa-spin text-success" />;
    } else if (wsStatus === 'closed') {
      return (
        <i className="fa fa-exclamation-circle text-warning">
          {' '}{this.intlMsg.msg('detailview.wsstatus.closed')}
        </i>
      );
    } else if (wsStatus === 'reconnecting') {
      return (
        <i className="fa fa-exclamation-circle text-warning">
          {' '}{this.intlMsg.msg('detailview.wsstatus.reconnecting')}
        </i>
      );
    }
    return null;
  }

  renderDataTable() {
    const { wsType } = this.props;
    const { dataList, dataExpanded = true } = this.state;
    let header;
    if (wsType === 'ws') {
      header = (
        <div>
          {this.intlMsg.msg('detailview.table.wstitle')}{' '}
          {this.renderWsStatus()}
          <ul className="icontools">
            <li>
              <CollapseToggle
                expanded={dataExpanded}
                onChange={v => this.setState({ dataExpanded: v })}
              />
            </li>
          </ul>
        </div>
      );
    } else {
      header = (
        <div>
          {this.intlMsg.msg('detailview.table.httptitle')}{' '}
          {this.renderWsStatus()}
          <ul className="icontools">
            <li>
              <CollapseToggle
                expanded={dataExpanded}
                onChange={v => this.setState({ dataExpanded: v })}
              />
            </li>
          </ul>
        </div>
      );
    }

    const rows = _.sortBy(dataList, d => -d.$time).map((item, index) => {
      let parsed = {};
      try {
        parsed = JSON.parse(item.data || '{}');
      } catch (e) {
        parsed = {};
      }
      if (!_.isEmpty(parsed)) {
        return (
          <tr key={index}>
            <td>{compactFormat(item.$time)}</td>
            <td>{normalizeDevEUI(item.deveui)}</td>
            <td>{item.data}</td>
            <td>{item.fport}</td>
          </tr>
        );
      }
      return null;
    });

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={dataExpanded}
      >
        <Table className="aisz-table-light" striped hover bordered responsive>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('detailview.data.title')}</th>
              <th>DevEUI</th>
              <th>
                <i className="fa fa-envelope" aria-hidden="true" />{' '}
                {this.intlMsg.msg('detailview.data.data')}
              </th>
              <th>fPort</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </Panel>
    );
  }

  renderCharts() {
    const {
      deveui = '',
      fport = '',
      chartsExpanded = {},
      chartsResizes = {},
    } = this.state;
    let { dataList = [] } = this.state;
    dataList = _.sortBy(dataList, '$time');
    dataList = _.filter(dataList, item => (
      (deveui === '' || item.deveui === deveui) &&
      (fport === '' || item.fport === fport)));
    dataList = _.filter(dataList, (item) => {
      let parsed = {};
      try {
        parsed = JSON.parse(item.data || '{}');
      } catch (e) {
        parsed = {};
      }
      return !_.isEmpty(parsed);
    });
    dataList = _.map(dataList, (item) => {
      let parsed = {};
      try {
        parsed = JSON.parse(item.data || '{}');
      } catch (e) {
        parsed = {};
      }
      return {
        ...item,
        parsed,
      };
    });

    const metrics = _.uniq(_.flatMap(dataList, item => _.keys(item.parsed)));
    const categories = _.map(dataList, item => format(item.$time, 'YYYY-MM-DD HH:mm:ss'));

    if (metrics.length === 0) {
      return (
        <Panel bsStyle="aisz-white">
          <div className={styles.noMetrics}>
            {this.intlMsg.msg('parserview.nometrics')}
            <div className={styles.guide}>
              {this.intlMsg.msg('parserview.nometrics.desc')}
            </div>
          </div>
        </Panel>
      );
    }

    return metrics.map(metric => (
      <Panel
        bsStyle="aisz-white"
        header={(
          <div>
            {metric}
            <ul className="icontools">
              <li>
                <CollapseToggle
                  expanded={_.has(chartsExpanded, metric) ? chartsExpanded[metric] : true}
                  onChange={v => this.setState({
                    chartsExpanded: {
                      ...chartsExpanded,
                      [metric]: v,
                    },
                  })}
                />
              </li>
            </ul>
          </div>
        )}
        key={metric}
        collapsible
        expanded={_.has(chartsExpanded, metric) ? chartsExpanded[metric] : true}
        onEntered={() => {
          this.setState({
            chartsResizes: {
              ...chartsResizes,
              [metric]: Math.random(),
            },
          });
        }}
      >
        <LineChart
          yAxis={[
            {
              name: metric,
              splitNumber: 5,
            },
          ]}
          xAxis={{
            axisTick: {
              alignWithLabel: true,
            },
            boundaryGap: true,
          }}
          series={[
            {
              data: dataList.map(item => item.parsed[metric]),
              name: metric,
              yAxisIndex: 0,
            },
          ]}
          categories={categories}
          dataZoom={[{
            type: 'slider',
            fillerColor: 'rgba(228, 241, 254, 0.4)',
            dataBackground: {
              lineStyle: {
                width: 0,
              },
              areaStyle: {
                color: 'rgba(107, 185, 240, 0.8)',
              },
            },
          }]}
          resize={chartsResizes[metric]}
        />
      </Panel>
    ));
  }

  renderToolbar() {
    const breadcrumb = [{
      content: this.intlMsg.msg('detailview.nav.api'),
      onClick: () => this.props.pushState(`/application/${this.props.appId}/api`),
    }, {
      content: this.intlMsg.msg('parserview.breadcrumb.title'),
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const { deveui = '', fport = '' } = this.state;
    const devSelect = (
      <Select
        value={deveui}
        options={this.deveuiOptions()}
        onChange={v => this.setState({ deveui: v })}
      />
    );
    const fportSelect = (
      <Select
        value={fport}
        options={this.fPortOptions(deveui)}
        onChange={v => this.setState({ fport: v })}
      />
    );

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderParser()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderDataTable()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PanelToolbar
              tools={[
                <ControlLabel className="aisz-control-label">DevEUI</ControlLabel>,
                devSelect,
                <ControlLabel className="aisz-control-label">fPort</ControlLabel>,
                fportSelect,
              ]}
            />
            <div className={styles.charts}>
              {this.renderCharts()}
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

ParserView.defaultProps = defaultProps;
ParserView.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(ParserView));





// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/AppDebug/coms/ParserView/index.jsx